import { stagger } from 'framer-motion';
const EASE = [0.22, 1, 0.36, 1];
export const container = {
    hidden: {},
    visible: {
        transition: {
            delayChildren: stagger(0.08),
        },
    },
};
export const fadeUp = {
    hidden: { opacity: 0, y: 16 },
    visible: {
        opacity: 1,
        y: 0,
        transition: {
            duration: 0.55,
            ease: EASE, // premium easing
        },
    },
};
export const fadeIn = {
    hidden: { opacity: 0 },
    visible: {
        opacity: 1,
        transition: { duration: 0.4 },
    },
};
